import type { VersionApi } from '../generated'
import { createAPISlice } from './createAPISlice'

export default function createSystemApis(versionApi: VersionApi) {
  return createAPISlice({
    appVersion: async () => {
      return await versionApi.version()
    },
  })
}
